import { useRef, useEffect } from "react"


function isPassCodeTyped(arr: string[], code: string | undefined) {
  return arr.join('') === code
}

export function useKeyPress(key: string, handler: () => void, oneTimeOnly = false) {

  const lastPressed = useRef<string | null>(key)
 
  useEffect(() => {
    if(!key || !lastPressed.current) {
      return
    }
    function onKeyDown(e: KeyboardEvent): any {
      lastPressed.current = e.key
      if(e.key && lastPressed.current) {
        if(key === e.key) {
          if(oneTimeOnly) {
            lastPressed.current = null
            document.removeEventListener('keydown', onKeyDown)
          }
          handler()
        }
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [key, handler])




}

export function useKeyPhrase(code: string | undefined, handler: () => void, oneTimeOnly = false) {

  const lastPressed = useRef<string[]>(code ? code.split('').map(() => '') : [])
 
  useEffect(() => {
    if(!code || !lastPressed.current) {
      return
    }
    function onKeyDown(e: KeyboardEvent): any {
      if(e.key.length === 1 && code) {
        lastPressed.current.shift()
        lastPressed.current.push(e.key)
        if(isPassCodeTyped(lastPressed.current, code)) {
          lastPressed.current = code.split('').map(() => '')
          if(oneTimeOnly) {
            document.removeEventListener('keydown', onKeyDown)
          }
          handler()
        }
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [code, handler])




}

